<template>
    <v-dialog width="400px" v-model="dialog">

        <template v-slot:activator="{ on: {click} }" class="primary">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <span v-on="disabled && on">
                        <v-btn
                            v-on:click="click"
                            :disabled="disabled">
                            <v-icon>mdi-file-document-outline</v-icon>&nbsp;Invoice
                        </v-btn>
                    </span>
                </template>
                <span>Restaurant not selected</span>
            </v-tooltip>
        </template>

        <v-card v-if="dialog">
            <v-card-title>
                <span class="headline">Request invoice</span>
                <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
            </v-card-title>
            <v-card-text>
                <v-row align="stretch">
                    <!-- right panel -->
                    <v-col>
                        <v-form ref="form">
                            <v-row v-if="intersection_invoice">
                                <v-col cols="12" sm="12" md="12">
                                    <v-alert type="warning">
                                        Found invoice on taken period.<br>
                                        Number: {{intersection_invoice.invoice_number}}, period from {{intersection_invoice.period_date_from | headerDate}} to {{intersection_invoice.period_date_to | headerDate}}
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                        outlined
                                        label="Invoice number*"
                                        hint="A000125"
                                        required
                                        v-model="invoice_number"
                                        :error-messages="invoiceNumberErrors"
                                        @input="$v.invoice_number.$touch()"
                                        @blur="$v.invoice_number.$touch()"
                                        dense
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                            outlined
                                            label="Сommission £ / hour *"
                                            hint="Dream Drivers Сommission"
                                            required
                                            v-model="comission"
                                            :error-messages="invoiceComissionErrors"
                                            @input="$v.comission.$touch()"
                                            @blur="$v.comission.$touch()"
                                            dense
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-checkbox
                                        v-model="create_invoice_checkbox"
                                        :label="`Build invoice for restaurant`"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>

                            <div class="d-flex justify-center">
                                <v-btn
                                        depressed
                                        class="mr-4 primary"
                                        :disabled="this.$v.$invalid || localLoading"
                                        :loading="localLoading"
                                        @click="preview"
                                ><v-icon left>mdi-eye</v-icon>Preview</v-btn>
                                <v-btn
                                        depressed
                                        class="mr-4 primary"
                                        :disabled="this.$v.$invalid || localLoading"
                                        :loading="localLoading"
                                        @click="submit"
                                ><v-icon left>mdi-upload</v-icon>Download</v-btn>
                                <v-btn
                                        class="mr-4 warning"
                                        :loading="localLoading"
                                        depressed
                                        @click="dialog=false"
                                ><v-icon left>mdi-cancel</v-icon>Cancel</v-btn>
                            </div>

                        </v-form>
                    </v-col>
                    <!--/ right panel -->
                </v-row>
            </v-card-text>
        </v-card>

    </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required,/* maxLength, email, numeric */ } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import moment from 'moment';
import * as _ from 'lodash';

export default {
    mixins: [validationMixin],
    name: "RequestInvoiceModal",
    props: ['periodDateFrom', 'periodDateTo', 'restaurantId', 'driverId', 'disabled', "comission"],
    validations: {
        invoice_number: { required },
        comission: { required },
    },
    data: () => ({
        /*valid: false,*/
        localLoading: false,
        dialog: false,
        // -- form fields
        invoice_number: void 0,
        // comission: 1.5,
        create_invoice_checkbox: true,
        intersection_invoice: void 0,
        is_initialized: false,
    }),
    computed: {
        ...mapGetters([
            'invoice_last_id',
            'invoice_intersection',
        ]),
        invoiceNumberErrors () {
            const errors = [];
            if (!this.$v.invoice_number.$dirty) {
                return errors;
            }
            !this.$v.invoice_number.required && errors.push('Invoice number is required');
            return errors
        },
        invoiceComissionErrors () {
            const errors = [];
            if (!this.$v.comission.$dirty) {
                return errors;
            }
            !this.$v.comission.required && errors.push('Сommission is required');
            return errors
        },
    },
    updated() {
        if (!this.$data.dialog) {
            this.$data.is_initialized = false;
            this.intersection_invoice = void 0;
            return; // exit dialog closed
        }

        if (this.$data.is_initialized) {
            return;
        }

        this.$data.is_initialized = true;

        // check invoice period exists, and get new number
        this.intersection_invoice = void 0;
        this.$store.dispatch('fetchInvoiceCheck', {
            period_date_from: this.periodDateFrom,
            period_date_to: this.periodDateTo,
            restaurant_id: this.restaurantId,
        }).then((/*data*/) => {
            if (!this.invoice_number) {
                this.invoice_number = this.zeros(String(this.invoice_last_id), 3);
            }
            if (!_.isEmpty(this.invoice_intersection)) {
                let invoice = this.invoice_intersection[0];
                this.intersection_invoice = invoice;
            }
        });
    },
    methods: {
        submit () {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                // create new time sheet
                this.localLoading = true;
                var invoice_data = {
                    invoice_number: this.invoice_number,
                    comission: this.comission,
                    period_date_from: this.periodDateFrom,
                    period_date_to: this.periodDateTo,
                    restaurant_id: this.restaurantId,
                    driver_id: this.driverId
                };
                
                if (this.create_invoice_checkbox) {
                    invoice_data.create_invoice = '1';
                }

                this.$store.dispatch('requestInvoice', invoice_data).then(() => {
                    if (this.create_invoice_checkbox) {
                        this.$emit('invoiceGenerated', '');
                    }

                    this.clear(); // reset form
                    this.dialog = false; // close dialog
                    this.invoice_number = void 0;
                    this.create_invoice_checkbox = true;
                }).finally(() => {
                    this.localLoading = false;
                });
            }
        },
        preview () {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                // create new time sheet
                this.localLoading = true;
                var invoice_data = {
                    invoice_number: this.invoice_number,
                    comission: this.comission,
                    period_date_from: this.periodDateFrom,
                    period_date_to: this.periodDateTo,
                    restaurant_id: this.restaurantId,
                    driver_id: this.driverId
                };

                this.$store.dispatch('previewInvoice', invoice_data).then(() => {
                    // if (this.create_invoice_checkbox) {
                    //     this.$emit('invoiceGenerated', '');
                    // }

                    // this.clear(); // reset form
                    // this.dialog = false; // close dialog
                    // this.invoice_number = void 0;
                    // this.create_invoice_checkbox = true;
                }).finally(() => {
                    this.localLoading = false;
                });
            }
        },
        zeros(str, lng) {
            var factlength = str.length;
            if (factlength < lng) {
                for (var i = 0; i < (lng-factlength); i++) {
                    str = '0' + str;
                }
            }
            return str;
        },
        clear () {
            this.$v.$reset();
            this.invoice_number = void 0;
            this.comission = 1.5;
        },
    },
    filters: {
        headerDate: function (date) {
        return moment(date, "YYYY-MM-DD").format('DD/MM/YYYY');
        },
    },
}
</script>

<style scoped>

</style>
